$(function () {
    var widget = $('.hindle-side-widget.-location');
    var box = $('.hindle-side-widget.-location .map');

    if (box.length === 0) {
        return;
    }

    var point = {
        lat: box.data('lat'),
        lng: box.data('lng'),
        title: box.data('title'),
        marker: true
    };

    widget.addClass('-active');

    box.mapify({
        points: [
            point
        ],
        zoom: 15,
        responsive: true,
        key: GOOGLE_MAPS_API_KEY
    });
});
